module.exports = __webpack_public_path__ + "static/media/earth.4d2d26d2.png";